/**
 * Mobile Visual Nav - Hide on Scroll Down
 * Mimics the StoreHeader hide-on-scroll behavior
 */

// Simple throttle utility
function throttle(fn, wait = 50) {
  let inThrottle, lastFn, lastTime;
  return function() {
    const context = this, args = arguments;
    if (!inThrottle) {
      fn.apply(context, args);
      lastTime = Date.now();
      inThrottle = true;
    } else {
      clearTimeout(lastFn);
      lastFn = setTimeout(function() {
        if (Date.now() - lastTime >= wait) {
          fn.apply(context, args);
          lastTime = Date.now();
        }
      }, Math.max(wait - (Date.now() - lastTime), 0));
    }
  };
}

class MobileVisualNav extends HTMLElement {
  connectedCallback() {
    // Only activate on mobile (matching the @media query in the section)
    if (window.matchMedia('(min-width: 700px)').matches) {
      return;
    }

    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      this._lastScrollTop = 0;
      this._accumulatedScroll = 0;
      this._isVisible = true;
      window.addEventListener('scroll', throttle(this._onScroll.bind(this)));
    }
  }

  async hide() {
    if (!this._isVisible) return;

    this._isVisible = false;
    const section = this.closest('.shopify-section');

    // Quick, smooth slide up when hiding
    const animation = this.animate(
      { transform: ['translateY(0)', 'translateY(-100%)'] },
      { duration: 250, easing: 'cubic-bezier(0.4, 0, 0.6, 1)', fill: 'forwards' }
    );

    await animation.finished;

    if (section) {
      section.style.visibility = 'hidden';
    }
  }

  show() {
    if (this._isVisible) return;

    const section = this.closest('.shopify-section');
    if (section) {
      section.style.visibility = 'visible';
    }

    // Gentle, smooth slide down when showing - longer duration with ease-out
    this.animate(
      { transform: ['translateY(-100%)', 'translateY(0)'] },
      { duration: 400, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' }
    );

    this._accumulatedScroll = 0;
    this._isVisible = true;
  }

  _onScroll() {
    // Ignore negative scroll (bounce effect on mobile)
    if (window.scrollY < 0) {
      return;
    }

    // Accumulate downward scroll
    this._accumulatedScroll = Math.max(
      0,
      this._accumulatedScroll + (window.scrollY - this._lastScrollTop)
    );

    // Scrolling up - show immediately
    if (window.scrollY < this._lastScrollTop) {
      this.show();
    }
    // Scrolling down - hide after threshold
    else if (this._accumulatedScroll > 100) {
      this.hide();
    }

    this._lastScrollTop = window.scrollY;
  }
}

if (!customElements.get('mobile-visual-nav')) {
  customElements.define('mobile-visual-nav', MobileVisualNav);
}

